const base = require("./base");
const query = require("./utils/query_browser");

module.exports = {
	...base,
	query
}
